var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShovel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "22.975 27.762 144.364 144.438",
    viewBox: "22.975 27.762 144.364 144.438",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m166.8 61.6-33.3-33.3c-.7-.7-1.8-.7-2.5-.1L114.2 43c-.6.5-.8 1.3-.5 2.1l7.2 18.3-41.1 41.1-16.7-16.9c-.7-.7-1.9-.7-2.6 0l-37 37c-.4.4-.6 1.1-.5 1.7l7.4 37c.1.7.7 1.3 1.5 1.5l37 7.4h.4c.5 0 1-.2 1.3-.5l37-37c.7-.7.7-1.9 0-2.6L90 114.5l41-41 19 7.9c.7.3 1.6.1 2.1-.5l14.8-16.7c.6-.8.6-1.9-.1-2.6zm-63.2 71.7-4.8 4.8-9.8-9.8c-.7-.7-1.9-.7-2.6 0-.7.7-.7 1.9 0 2.6l9.8 9.8-27.6 27.6-34.9-7-7-34.9 27.6-27.6 9.8 9.8c.4.4.8.5 1.3.5s.9-.2 1.3-.5c.7-.7.7-1.9 0-2.6L57 96.3l4.8-4.8 15.6 15.6-14.7 14.7c-1.3 1.3-2.1 3.1-2.1 5s.7 3.7 2.1 5c1.3 1.3 3.1 2.1 5 2.1s3.7-.7 5-2.1l14.7-14.7 16.2 16.2zm46.6-55.9-18.9-7.9c-.7-.3-1.5-.1-2 .4L70 129.2c-1.3 1.3-3.5 1.3-4.8 0-.6-.6-1-1.5-1-2.4s.4-1.8 1-2.4l59.3-59.3c.5-.5.7-1.3.4-2L117.7 45l14.4-12.8L162.9 63l-12.7 14.4zm-19.4-34.3c.7-.7 1.9-.7 2.6 0l16.7 16.7c.7.7.7 1.9 0 2.6-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5l-16.7-16.7c-.7-.7-.7-1.9 0-2.6z",
    fill: "#8F8C8C",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShovel);
export default __webpack_public_path__ + "static/media/icon-shovel.c11dd31d25b8a0eba31a9c4366a874d0.svg";
export { ForwardRef as ReactComponent };